// Uses native fetch (not HttpService) intentionally: target URLs are S3 signed
// URLs pre-authenticated via query-string signature. Adding an Authorization
// header via HttpService would cause S3 to reject the request.

export class DownloadHttpError extends Error {
  constructor(public readonly status: number) {
    super(`Fetch failed: ${status}`);
  }
}

export async function downloadFile(
  url: string,
  filename: string | null | undefined,
): Promise<void> {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new DownloadHttpError(response.status);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = filename ?? "";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(blobUrl), 0);
  } catch (error) {
    if (error instanceof DownloadHttpError) {
      // A real, readable non-2xx status — not a CORS block. Retrying the
      // same URL would just hit the same failure again.
      throw error;
    }

    // Fallback for CORS-restricted URLs: direct anchor without _blank so the
    // browser's Content-Disposition header still triggers a download.
    const a = document.createElement("a");
    a.href = url;
    if (filename) a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}
